export default "__VITE_ASSET__CXp5VUHU__"